export default __webpack_public_path__ + "static/media/profile-standard.3ca0dfab.jpg";